<template>
  <v-container
    fill-height
    fluid
  >
    <helper-suspended ref="suspended" />
    <v-flex v-if="!$apollo.loading">
      <v-card>
        <v-layout
          wrap
        >
          <v-flex
            xs12
          >
            <v-btn
              class="text-right"
              small
              text
              outlined
              @click="requestWithdrawal()"
            >
              {{ $t('withdrawals.withdrawButton') }}
            </v-btn>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              v-if="withdrawals !== undefined && !_.isEmpty(withdrawals.data)" 
              class="text-no-wrap"
              :headers="headers"
              :footer-props="{
                'items-per-page-options': [10, 15, 25, 50, 100, 200]
              }"
              :locale="$i18n.locale"
              :items="withdrawals.data"
              :items-per-page="withdrawals.per_page"
              :page="withdrawals.current_page"
              :server-items-length="withdrawals.total"
              :hide-default-footer="_.isEmpty(withdrawals.data)"
              dense
              @update:items-per-page="reload($event, 'count')"
              @update:page="reload($event, 'page')"
            >
              <template v-slot:item.created_at="{ item }">
                <small v-if="item.status == 'completed'">{{ item.completed_at | moment('L LTS') }}</small>
                <small v-else>{{ item.created_at | moment('L LTS') }}</small>
              </template>

              <template v-slot:item.amount="{ item }">
                <b>{{ item.amount }} {{ item.currency }}</b>
              </template>
              <template v-slot:item.fee="{ item }">
                <small>{{ item.fee }} {{ item.fee_currency ? item.fee_currency : item.currency }}</small>
              </template>
              <template v-slot:item.blockchain="{ item }">
                <small>{{ item.blockchain }}</small>
              </template>
              <template v-slot:item.status="{ item }">
                <small>
                  <b :class="colorStatus(item.status)">{{ $t('withdrawals.'+item.status) }}</b>
                </small>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-btn
                  v-if="item.status == 'new'"
                  x-small
                  text
                  @click="cancelWithdrawal(item.id)"
                >
                  {{ $t('globals.cancelButton') }}
                </v-btn>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex
            v-if="withdrawals !== undefined && _.isEmpty(withdrawals.data)"
            class="not-found"
          >
            <v-icon>mdi-ghost</v-icon>
            <p>{{ $t('withdrawals.notFound') }}</p>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <request-dialog
      v-if="requestDialog"
      :show-dialog="requestDialog"
      :withdrawal-id="withdrawalId"
    />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
const WITHDRAWALS_QUERY = require("@/graphql/queries/Withdrawals.gql");
import RequestDialog from "@/views/Affiliates/partial/RequestDialog.vue";
import CANCEL_WITHDRAWAL_MUTATION from "@/graphql/mutations/CancelWithdrawal.gql";

export default {
  name: "Withdrawals",
  components: {
    RequestDialog
  },
  data() {
    return {
      loading: false,
      userStatus: null,
      requestDialog: false,
      withdrawalId: null,
      params: {
        id: this.$route.params.id,
        page: 1,
        count: 25
      },
      headers: [
        {
          sortable: false,
          text: this.$t("withdrawals.date"),
          value: "created_at"
        },
        {
          sortable: false,
          text: this.$t("withdrawals.amount"),
          value: "amount"
        },
        {
          sortable: false,
          text: this.$t("withdrawals.netFee"),
          value: "fee"
        },
        {
          sortable: false,
          text: this.$t("withdrawals.blockchain"),
          value: "blockchain"
        },
        {
          sortable: false,
          text: this.$t("withdrawals.status"),
          value: "status"
        },
        {
          sortable: false,
          text: "",
          value: "actions"
        }
      ]
    };
  },
  computed: {
    ...mapGetters("user", ["getUserSettings"]),
  },
  beforeDestroy() {
    this.$apollo.queries.withdrawals.stopPolling();
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "user/setUserSettings") {
        this.userStatus = state.user.userSettings.status
      }
    });
  },
  methods: {
    requestWithdrawal() {
      if (this.userStatus == 'suspended') {
        this.$refs.suspended.open();
        return;
      }
      this.withdrawalId = null;
      this.requestDialog = true;
    },
    cancelWithdrawal(withdrawalId) {
      this.$apollo
        .mutate({
          mutation: CANCEL_WITHDRAWAL_MUTATION,
          variables: {
            id: withdrawalId
          }
        })
        .then(data => {
          this.$apollo.queries.withdrawals.refetch();
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    },
    reload(value, from) {
      this.params[from] = value;
      this.$apollo.queries.withdrawals.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult;
        }
      });
    }
  },
  apollo: {
    withdrawals: {
      query: WITHDRAWALS_QUERY,
      fetchPolicy: "network",
      pollInterval: 30 * 1000,
      variables() {
        return this.params;
      }
    }
  }
};
</script>

<style lang="scss">
</style>
